import React from "react";

const ImageWithPlaceholder = ({
  src,
  alt = "",
  eager = false,
  ...props
}) => (
  <img
    src={src}
    alt={alt}
    loading={eager ? "eager" : "lazy"}
    decoding="async"
    {...props}
  />
);

export default ImageWithPlaceholder;
